<template>
  <Preloader v-if="loading" />
  <div v-else>
    <VacancyFaqForm
      v-model="faqQuestionText"
      :vacancy="vacancy"
      :common-faq="commonFaq"
    />
    <Confirm
      :title="$t('questionNotSaved')"
      :cancel-text="$t('continue')"
      :confirm-text="$t('done')"
      :max-width="500"
      :condition="faqQuestionText !== null && faqQuestionText.length > 0"
      @confirmed="done"
    >
      <template #activator="{ on: { click }}">
        <VBtn
          dark
          color="success"
          class="mt-12"
          @click="click"
          elevation="0"
        >
          {{ $t('done') }}
        </VBtn>
      </template>
    </Confirm>
  </div>
</template>

<script>
import ValidationMixin from '../../mixins/ValidationMixin';
import Preloader from '../Preloader.vue';
import VacancyFaqForm from './VacancyFaqForm.vue';
import Confirm from '../Confirm.vue';
import VacancyFaqCommon from '../../orm/models/Vacancy/VacancyFaqCommon';

export default {
  name: 'VacancyFaqEdit',
  metaInfo() {
    return {
      title: 'Вопрос-ответ о вакансии',
    };
  },
  components: { Preloader, VacancyFaqForm, Confirm },
  mixins: [ValidationMixin],
  props: {
    vacancy: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      faqQuestionText: null,
    };
  },
  computed: {
    commonFaq() {
      return VacancyFaqCommon.query().all();
    },
  },
  created() {
    this.init();
  },
  methods: {
    async init() {
      this.withLoading(async () => {
        await VacancyFaqCommon.api().fetch();
      });
    },
    async done() {
      await this.$router.push({ name: 'vacancy', params: { vacancyId: this.vacancy.id } });
    },
  },
};
</script>

<i18n locale="en" lang="yaml">
  questionNotSaved: You did not save the question
  continue: Continue editing
  done: Done
</i18n>

<i18n locale="ru" lang="yaml">
  questionNotSaved: Вы не сохранили вопрос
  continue: Продолжить редактирование
  done: Готово
</i18n>
